module.exports = __webpack_public_path__ + "media/请帅哥拍照.ec132e47.mp3";